import type { ReactNode } from 'react'
import { cx } from './cx'

export interface SegmentedControlProps<V extends string> {
  options: Array<{ value: V; label: ReactNode }>
  value: V
  onChange: (value: V) => void
  label: string
}

export function SegmentedControl<V extends string>({ options, value, onChange, label }: SegmentedControlProps<V>) {
  return (
    <div role="group" aria-label={label} className="inline-flex gap-0.5 rounded-lg bg-surface-raised p-[3px]">
      {options.map(option => {
        const pressed = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={pressed}
            onClick={() => onChange(option.value)}
            className={cx(
              'h-[30px] rounded-md px-2.5 text-[13px]',
              'focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-focus',
              pressed ? 'bg-surface font-semibold text-ink shadow-sm' : 'text-ink-secondary hover:text-ink'
            )}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
